module.exports = __webpack_public_path__ + "static/media/jumboton.5cf9d09e.png";


//////////////////
// WEBPACK FOOTER
// /src/assets/img/jumboton.png
// module id = 2173
// module chunks = 0